import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import ColorScale from '_class/ColorScale';
/* Compontent for selecting objects from a Matrix */

var MatrixAssessmentBlock = /*#__PURE__*/function (_Component) {
  _inherits(MatrixAssessmentBlock, _Component);

  var _super = _createSuper(MatrixAssessmentBlock);

  function MatrixAssessmentBlock(props) {
    var _this;

    _classCallCheck(this, MatrixAssessmentBlock);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "descriptionStepSelected", function (step) {
      if (_this.props.assessments != null) {
        var selectedUsers = null;

        if (_this.props.studentAssessment != null) {
          selectedUsers = [_this.props.items[0]];
        } else {
          if (_this.props.groupAssignment) {
            _this.props.items.forEach(function (task) {
              task.students.forEach(function (student) {
                if (student.selected) {
                  if (selectedUsers == null) {
                    selectedUsers = [];
                  }

                  selectedUsers.push(student);
                }
              });
            });
          } else {
            selectedUsers = _this.props.items.filter(function (t) {
              return t.selected;
            });
          }
        }

        if (selectedUsers.length == 1) {
          var studentId = "";

          if (_this.props.referenceType == "Plan") {
            studentId = selectedUsers[0].id;
          } else {
            if (_this.props.groupAssignment) {
              studentId = selectedUsers[0].id;
            } else {
              studentId = selectedUsers[0].assignedTo;
            }
          }

          var assessment = _this.props.assessments.find(function (t) {
            return t.studentId == studentId;
          });

          if (assessment != null) {
            var detail = assessment.assessmentDetails.find(function (t) {
              return t.rowId == _this.props.block.id && t.cellId == step.id;
            });

            if (detail != null) {
              return true;
            }
          }
        }
      }

      return false;
    });

    _this.state = {
      userClicked: false
    };

    _this.onStepSelect.bind(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(MatrixAssessmentBlock, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.block.cells.forEach(function (step) {
        step.selected = false;
      });
    }
  }, {
    key: "onStepSelect",
    value: function onStepSelect(step) {
      var _this2 = this;

      if (this.props.disabled != null && this.props.disabled) {} else {
        if (this.props.type == "single") {
          step.selected = step.selected ? false : true;
          this.props.block.cells.forEach(function (blockStep) {
            return blockStep.selected == null ? blockStep.selected = false : null;
          });
        } else {
          var index = this.props.block.cells.findIndex(function (t) {
            return t.id == step.id;
          });
          var nextStep = this.props.block.cells[index + 1];

          if (index != 0) {
            if (nextStep != null && nextStep.selected) {
              step.selected = step.selected ? true : false;
            } else {
              step.selected = step.selected ? false : true;
            }
          }

          this.props.block.cells.forEach(function (blockStep, i) {
            if (index > 0 && i == 0) {
              /* Handle F Grade */
              blockStep.selected = false;
            } else if (index == 0 && i == 0) {
              blockStep.selected = step.selected ? false : true;
            }

            if (index > i && i > 0) {
              /* Handle rest of Grades */
              blockStep.selected = step.selected ? true : false;
            } else if (index == i) {} else if (i != 0) {
              blockStep.selected = false;
            }
          });
        }

        this.setState({
          userClicked: true
        }, function () {
          if (_this2.props.type == "single") {
            _this2.props.onMatrixDescriptionAssessmentUpdate(_this2.props.block, step, _this2.props.details);
          } else {
            _this2.props.onMatrixAssessmentUpdate(_this2.props.block, _this2.props.details);
          }
        });
      }
    }
  }, {
    key: "getGrade",
    value: function getGrade(index) {
      var type = this.props.type;

      if (type == "single") {
        index = index + 1;
      }

      if (index == 0) {
        return "F";
      } else if (index == 1) {
        return "E";
      } else if (index == 2) {
        return "C";
      } else if (index == 3) {
        return "A";
      } else {
        return "A";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var highestGrade = "";

      if (this.props.assessments != null) {
        var selectedUsers = null;

        if (this.props.studentAssessment != null) {
          selectedUsers = [this.props.items[0]];
        } else {
          if (this.props.groupAssignment) {
            this.props.items.forEach(function (task) {
              task.students.forEach(function (student) {
                if (student.selected) {
                  if (selectedUsers == null) {
                    selectedUsers = [];
                  }

                  selectedUsers.push(student);
                }
              });
            });
          } else {
            selectedUsers = this.props.items.filter(function (t) {
              return t.selected;
            });
          }
        }

        if (selectedUsers.length == 1) {
          var studentId = "";

          if (this.props.referenceType == "Plan" || this.props.referenceType == "TeamsAssignment") {
            studentId = selectedUsers[0].id;
          } else {
            if (this.props.groupAssignment) {
              studentId = selectedUsers[0].id;
            } else {
              studentId = selectedUsers[0].assignedTo;
            }
          }

          var assessment = this.props.assessments.find(function (t) {
            return t.studentId == studentId;
          });

          if (assessment != null) {
            var detail = assessment.assessmentDetails.find(function (t) {
              return t.rowId == _this3.props.block.id;
            });

            if (detail != null) {
              highestGrade = detail.cellId;
            }
          }
        }
      }

      var foundGrade = false;
      var colors = new ColorScale(this.props.block.cells.length).get();
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.sentenceNr != null ? this.props.sentenceNr == 1 ? "matrix-block paragraph" : "matrix-block" : "matrix-block",
        key: this.props.block.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-title"
      }, this.props.index ? /*#__PURE__*/React.createElement("span", null, this.props.index, "\xA0") : null, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: this.props.block.text.replace(new RegExp("\r\n", "g"), "<br />")
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "matrix-block-steps"
      }, this.props.block.cells.map(function (step, index) {
        var grade = _this3.getGrade(index);

        if (_this3.props.type == "multiple") {
          if (highestGrade != "" && _this3.state.userClicked == false) {
            if (grade == highestGrade && foundGrade == false) {
              foundGrade = true;
              step.selected = true;
            } else if (highestGrade == step.id && foundGrade == false) {
              foundGrade = true;
              step.selected = true;
            } else if (grade != highestGrade && foundGrade == false && grade != "F") {
              step.selected = true;
            }
          } else if (highestGrade == "" && _this3.state.userClicked == false) {
            step.selected = false;
          }
        } else {
          var selected = _this3.descriptionStepSelected(step);

          step.selected = selected;
        }

        return /*#__PURE__*/React.createElement("div", {
          className: step.selected ? "matrix-block-step selected grade-".concat(grade) : "matrix-block-step grade-".concat(grade),
          key: step.id,
          style: {
            '--level-color': colors[index]
          },
          onClick: _this3.onStepSelect.bind(_this3, step)
        }, /*#__PURE__*/React.createElement("div", {
          className: "matrix-block-step-description"
        }, step.text));
      }, this))));
    }
  }]);

  return MatrixAssessmentBlock;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {})(MatrixAssessmentBlock);